/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useSelector, useDispatch } from "react-redux";
import actionCreators from "../../store/Auth/actionCreators";
import { colors } from "../../common/styles/colors";
import { Button } from "@material-ui/core";
import { fontSize } from "../../common/styles/typography";
import { unstable_useMediaQuery as useMediaQuery } from "@material-ui/core/useMediaQuery";
import {
    USER_TYPE_ADMIN,
    USER_TYPE_MANAGER,
    USER_TYPE_STANDARD,
} from "@/app/UsersAndAudiences/LseStaff/values";

const Masqueraded = () => {
    const { isMasqueraded, firstName, lastName, permissionLevel } = useSelector(
        state => state.Auth
    );
    const dispatch = useDispatch();
    const isMobile = useMediaQuery("(max-width:767px)");

    return isMasqueraded ? (
        <div css={styles.root}>
            <div css={styles.body}>
                <div css={styles.title}>
                    You&apos;re currently masquerading as{" "}
                    <strong>
                        {firstName} {lastName}
                    </strong>
                </div>

                <div css={styles.subtitle}>
                    Permission Level:{" "}
                    <strong>
                        {permissionLevel === USER_TYPE_STANDARD
                            ? "Standard"
                            : permissionLevel === USER_TYPE_MANAGER
                            ? "Manager"
                            : permissionLevel === USER_TYPE_ADMIN
                            ? "Administrator"
                            : "Unknown"}
                    </strong>
                </div>
            </div>
            <div>
                <Button
                    size={"small"}
                    onClick={() => {
                        dispatch(actionCreators.logout.create());
                        window.close();
                    }}
                    style={{ backgroundColor: colors.white }}
                >
                    Stop masquerading
                </Button>
            </div>
        </div>
    ) : (
        <div />
    );
};

const styles = {
    root: {
        color: colors.white,
        backgroundColor: colors.red,
        height: 56,
        display: "flex",
        gap: 48,
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        top: 0,
        right: 0,
        left: 0,
        zIndex: 1000,
        "@media (max-width: 1023px)": {
            height: 90,
            padding: "0 16px",
            flexDirection: "column",
            textAlign: "center",
            alignItems: "stretch",
            gap: 8,
        },
    },
    body: {
        display: "flex",
        flexDirection: "column",
        gap: 2,
    },
    title: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        "@media (max-width: 1023px)": {
            fontSize: fontSize.textSmall,
        },
    },
    subtitle: {
        color: colors.white70,
        fontSize: fontSize.textSmaller,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
};

export default Masqueraded;
